import { useId, type ReactNode } from 'react';

import { Card, CardContent } from '../../ui/card';

export function PageSection(props: {
  title?: string;
  description?: string;
  actions?: ReactNode;
  /** A screen whose frame draws no card, or whose content already draws its own, opts out. */
  card?: boolean;
  children: ReactNode;
}): ReactNode {
  const titleId = useId();
  const hasHeading = props.title !== undefined || props.actions !== undefined;
  const heading = hasHeading && (
    <div className="flex flex-col gap-2 md:flex-row md:items-end md:justify-between">
      <div className="flex flex-col gap-1">
        {props.title !== undefined && (
          <h2 id={titleId} className="text-title-md">
            {props.title}
          </h2>
        )}
        {props.description !== undefined && (
          <p className="text-body-sm text-muted-foreground">{props.description}</p>
        )}
      </div>
      {props.actions !== undefined && (
        <div className="flex shrink-0 flex-wrap items-center gap-2">{props.actions}</div>
      )}
    </div>
  );
  const labelledBy = props.title !== undefined ? titleId : undefined;

  if (props.card === false) {
    return (
      <section aria-labelledby={labelledBy} className="flex flex-col gap-4">
        {heading}
        {props.children}
      </section>
    );
  }

  return (
    <section aria-labelledby={labelledBy}>
      <Card>
        <CardContent className="flex flex-col gap-4">
          {heading}
          {props.children}
        </CardContent>
      </Card>
    </section>
  );
}
